import { ClassificationType } from "@evergis/api";

import { ALL_UNIQUE_CLASSES_LIMIT, RANGE_MAX } from "../constants";
import { AppConfigState } from "../../../../appConfig/types";

export const getMaxClassifyClasses = (type: ClassificationType, appConfig: AppConfigState): number => {
  return [ClassificationType.Unique, ClassificationType.EqualInterval].includes(type)
    ? appConfig?.settings?.uniqueClassesLimit || ALL_UNIQUE_CLASSES_LIMIT
    : RANGE_MAX;
};
